import React, { useEffect, useState } from "react";
import back from "../../Asset/product/back.png";
import cartModel from "../../model/cart.model";
import Items from "../../component/cart/Items";
import DeleveryAddress from "../../component/cart/DeleveryAddress";
import PaymentMethod from "../../component/cart/PaymentMethod";
import CoupleCode from "../../component/cart/CoupleCode";
import OrderSummery from "../../component/cart/OrderSummery";
import { useLocation, useNavigate } from "react-router-dom";
import orderModel from "../../model/order.model";
import { toast } from "../../lib/helper";
import Deleverytime from "../../component/preordercart/Deleverytime";
import address from "../../Asset/toast/address.png"
import paymentmode from "../../Asset/toast/paymentmode.png"
import moment from "moment";
import date from "../../Asset/toast/date.png"
import wrong from "../../Asset/toast/wrong.png"
import logo from "../../Asset/ordercard/logo.png";
import { FaShoppingCart } from "react-icons/fa";
import cart2 from "../../Asset/recent/cart2.png";
import { BiSolidPurchaseTag } from "react-icons/bi";

const PreOrder = () => {
  const [cartlist, setCartList] = useState();
  const [Address, setAddress] = useState();
  const [paymentmethod, setPaymentmethod] = useState("");
  const [couponCode, setCouponCode] = useState("");
  const [newSummery, setNewSummery] = useState("");
  const Navigate = useNavigate();
  const location = useLocation();
  const [couponOn, setCouponOn] = useState(false);
  const [loading, setLoading] = useState(false);
 const [selectedDate, setSelectedDate] = useState(null);
 const [selectedOption, setSelectedOption] = useState("Morning");
 const [selectedMorTime, setSelectedMortime] = useState("6 am to 8 am"); 
   const [selectedEveTime, setSelectedEvetime] = useState("6 pm to 8 pm"); 
const[Loadings,setloadings]=useState(false)
  const Location = useLocation();


  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location?.pathname]);

  const Getcart = async () => {
    setLoading(true);
    cartModel
      .GetCart("pre_order")
      .then((responce) => {
        setCartList(responce?.data?.data);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        console.log("error", error);
      });
  };
  useEffect(() => {
    Getcart();
  }, []);

  const PlaceOrder = async () => {
    if(!Address?._id){
  toast("Please select a Address.", address);
    return;
}
  if (!selectedDate) {
    toast("Please select a pre-order date.", date);
    return;
  }
if (!paymentmethod) {
    toast("Please select a Payment.", paymentmode);
    return;
  }
  setloadings(true);
  const form = new FormData();
  form.append("delivery_address", Address?._id);
  form.append("payment_method", paymentmethod);
  form.append("coupon_code", couponCode);
  form.append("morning_or_evening", selectedOption);
  form.append("pre_order_date", moment(selectedDate).format("DD MMMM YYYY"));

  if (selectedOption === "Morning") {
    form.append("pre_order_time", selectedMorTime);
  } else {
    form.append("pre_order_time", selectedEveTime);
  }

  form.append("cart_type", "pre_order");

  orderModel
    .PlaceOrder(form)
    .then((responce) => {
      
      sessionStorage.setItem("neworderid", responce?.data?.newOrder?._id);
      sessionStorage.setItem("showOrderPopup", "true");
      Navigate("/");
      setloadings(false);
      console.log("ressss place order", responce);
    })
    .catch((error) => {
      toast(error?.response?.data?.message, wrong);
      console.log("error", error);
      setloadings(false);
    });
};
  const Validatecouple = async () => {
    const form = new FormData();
    form.append("coupon_code", couponCode);
    form.append("cart_type", "pre_order");
    cartModel
      .Validatecoupun(form)
      .then((responce) => {
        toast(responce?.data?.message, logo);
        setNewSummery(responce?.data?.data);
        console.log("gggg", responce);
      })
      .catch((error) => {
        toast(error?.response?.data?.message, wrong);
        console.log("error", error);
      });
  };
  useEffect(() => {
    if (couponCode && couponOn) {
      Validatecouple();
    }
  }, [couponCode]);
  console.log("location", Location);
  return (
    <div className="w-full pt-32  bg-[#f1f2eb] pl-8 pr-8  pb-44 lg:pl-20 lg:pr-20 lg:pt-32 lg:pb-52" style={{
      backgroundImage: `url(${back})`,
      backgroundRepeat: "repeat",
      backgroundSize: "auto",
    }}>
     <div className=" w-full md:w-3/4 flex gap-2 bg-Background1 p-2 lg:p-3 rounded-xl">
            <span className="w-44 title1 gap-2 py-1  hover:bg-Background2 flex items-center justify-center text-lg md:text-xl font-bold text-textColor text-center rounded-lg cursor-pointer"
            onClick={()=>{
                Navigate("/cart")
              }}>
          <FaShoppingCart />    Cart
            </span>
            <span
              className={`w-44 title1 gap-1 flex items-center justify-center hover:bg-Background2  text-lg md:text-xl font-bold py-1  ${
                Location?.pathname == "/preorder" && "bg-Background2"
              } text-textColor text-center rounded-lg cursor-pointer`}
              onClick={()=>{
                Navigate("/preorder")
              }}
            >
           <div className="w-6 ">
               
                <img src={cart2} alt="" className="w-full h-full object-cover" />
                
              </div>    Pre Order Cart
            </span>
            <span className="w-44 title1 flex gap-2 items-center justify-center hover:bg-Background2  text-lg md:text-xl font-bold text-textColor text-center rounded-lg cursor-pointer py-1 "
            onClick={()=>{
              Navigate("/subscribe")
            }}>
            <BiSolidPurchaseTag />   Subscribe
            </span>
          </div>
      {loading ? (
        <div className="w-full py-36 flex items-center justify-center">
          <span className="loading loading-ring loading-xs"></span>
          <span className="loading loading-ring loading-sm"></span>
          <span className="loading loading-ring loading-md"></span>
          <span className="loading loading-ring loading-lg"></span>
          <span className="loading loading-ring loading-xl"></span>
          <span className="loading loading-ring loading-lg"></span>
          <span className="loading loading-ring loading-md"></span>
          <span className="loading loading-ring loading-sm"></span>
          <span className="loading loading-ring loading-xs"></span>
        </div>
      ) : cartlist?.cart_items.length > 0 ? (
        <div className="w-full flex justify-center items-center">
        <div
          className="w-[98%] "
         
        >
          
          {/* items section */}
          <div className="mt-5 w-full">
            <Items
              datalist={cartlist?.cart_items}
              Getcart={Getcart}
              setNewSummery={setNewSummery}
              setCouponCode={setCouponCode}
            />
          </div>
          {/*second section*/}
          <div className="grid gap-20 grid-cols-1 lg:grid-cols-2">
            {/*left*/}
            <div className="w-full flex flex-col gap-8 mt-8 md:mt-0">
              <DeleveryAddress setAddress={setAddress} Address={Address} />
              <Deleverytime selectedDate={selectedDate} setSelectedDate={setSelectedDate} selectedOption={selectedOption} setSelectedOption={setSelectedOption}
              selectedMorTime={selectedMorTime} setSelectedMortime={setSelectedMortime} selectedEveTime={selectedEveTime} setSelectedEvetime={setSelectedEvetime}/>
              <PaymentMethod
                setPaymentmethod={setPaymentmethod}
                paymentmethod={paymentmethod}
              />
             
            </div>
            {/*right*/}
            <div className="w-full  flex flex-col gap-6 mt-6">
            <CoupleCode
                newSummery={newSummery}
                setNewSummery={setNewSummery}
                couponCode={couponCode}
                setCouponCode={setCouponCode}
                Validatecouple={Validatecouple}
                couponOn={couponOn}
                setCouponOn={setCouponOn}
              />
              <OrderSummery
                summery={cartlist?.cart_summary}
                newSummery={newSummery}
              />
              <div className="w-full">
                <button
                  className="bg-textColor text-white font-semibold w-full py-2 rounded-2xl"
                  onClick={PlaceOrder}
                >
                   {Loadings ? <span className="loading loading-dots loading-sm"></span> : "Place Order"} 
                </button>
              </div>
            </div>
          </div>
        </div>
        </div>
      ) : (
        <div
          className="w-full py-36 flex justify-center"
         
        >
          <span className="text-lg font-semibold text-textColor">
            No Item in Pre order
          </span>
        </div>
      )}
    </div>
  );
};

export default PreOrder;
